import { PageHeader } from '@@/PageHeader';
import { Widget, WidgetBody } from '@@/Widget';

import { CreateGitCredentialsForm } from './CreateGitCredentialsForm';

export function CreateGitCredentialsView() {
  return (
    <>
      <PageHeader
        title="Create git authentication"
        breadcrumbs={[
          { label: 'My account', link: 'portainer.account' },
          { label: 'Create git authentication' },
        ]}
        reload
      />

      <div className="row">
        <div className="col-sm-12">
          <Widget>
            <WidgetBody>
              <CreateGitCredentialsForm routeOnSuccess="portainer.account" />
            </WidgetBody>
          </Widget>
        </div>
      </div>
    </>
  );
}
